import { RuleActionAuditRecord } from '../../AIRules/types';
import { getAuditSubjectMemberId } from '../../AIRules/utils';

export const getMemberRuleActions = (
  actions: RuleActionAuditRecord[],
  memberId: string,
) => {
  return actions
    .filter(action => getAuditSubjectMemberId(action.subject_id) === memberId)
    .slice()
    .sort(
      (a, b) =>
        new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime(),
    );
};
